export const API_URL = 'https://www.townhallusa.com/';
export const API_PROD_URL = 'https://www.townhallusa.com/'
